import moment from "moment-timezone";
import { logOut } from "./api";

export const localWithUTCoffset = (
  time,
  timezone = "America/New_York",
  format = "HH:mm"
) => {
  let offset = moment()
    .tz(timezone)
    .utcOffset();
  return moment(time)
    .local()
    .utcOffset(offset)
    .format(format);
};
export const formatDate = (date, format) => {
  return moment(date)
    .local()
    .format(format);
};

export const utcWithtzInfo = (time, timezone = "America/New_York") => {
  if (time === "00:00") return "00:00";
  let withDate = moment(time, "HH:mm").toDate();
  return moment.tz(moment(withDate).format("HH:mm"), "HH:mm", timezone).utc();
};

export const getOnlyDate = date => {
  return date?.split("T")[0] || "";
};

export const checkAndGetTimezone = (timezone, dash) => {
  let timeZoneAbbre = moment()
    .tz(timezone)
    .zoneAbbr();

  return moment()
    .tz(timezone)
    .utcOffset() ===
    moment()
      .local()
      .utcOffset()
    ? ""
    : `${dash ? " - " : " "}${timeZoneAbbre}`;
};

export function adminEmployeeLogin(id) {
  const params = { id: id };
  loginAsEmployee(params).then(res => {
    let win = window.open(res.data.loginURL, "_blank");
    win.focus();
  });
}

export const orderDate = (item, cart, isOfficeAdmin) => {
  const orderDate = item?.attributes?.order_date;
  const cuttOff = item?.attributes?.cutoff;
  const cutoffDate = getOnlyDate(cuttOff);
  const format = "ddd, MMMM D, YYYY";
  const orderDateOnly = formatDateWithTimezone(
    orderDate,
    format,
    item?.attributes?.tzinfo
  );
  const deadlineDate = formatDateWithTimezone(
    cutoffDate,
    format,
    item?.attributes?.tzinfo
  );
  const deadlineTime = to12hourformat(
    localWithUTCoffset(cuttOff, item?.attributes?.tzinfo, "HH:mm a"),
    cart?.tzinfo
  );

  return isOfficeAdmin
    ? orderDate !== cutoffDate
      ? `${orderDateOnly} \nOrder deadline: ${deadlineDate}, ${deadlineTime}`
      : `Order deadline: ${orderDateOnly}, ${deadlineTime}`
    : `${orderDateOnly}`;
};

export function getMonth(date) {
  return moment(date).month();
}

export const longDateFormat = date => {
  return moment(date).format("dddd, MMMM Do YYYY");
};

export const formatTime12hour = time => {
  return moment(time)
    .local()
    .format("hh:mm a");
};

export const to12hourformat = (time, timeZone = "America/New_York") => {
  return `${moment(time, "HH:mm a").format("h:mm A")} ${checkAndGetTimezone(
    timeZone,
    true
  )}`;
};

export const status = (status, statusStopped) => {
  switch (status) {
    case "pending":
      return statusStopped ? "Closed due to capacity" : "Order Placed";
    case "preview":
      return statusStopped ? "Closed due to capacity" : "Sent to Restaurant";
    case "sent":
      return "Sent to Restaurant";
    case "confirmed":
      return "Sent to Restaurant";
    case "completed":
      return "Completed";
    case "order completed":
      return "Completed";
    case "cancelled":
      return "Cancelled";
    default:
      return status;
  }
};

export const officeAdminStatus = (status, statusStopped) => {
  switch (status) {
    case "pending":
      return statusStopped ? "Closed due to capacity" : "Order Placed";
    case "preview":
      return statusStopped ? "Closed due to capacity" : "Sent to Restaurant";
    case "sent":
      return "Sent to Restaurant";
    case "confirmed":
      return "Tap For ETA";
    case "completed":
      return "Completed";
    case "order completed":
      return "Completed";
    case "cancelled":
      return "Cancelled";
    default:
      return status;
  }
};

export const extractETA = (data, timezone = "America/New_York") => {
  // Do not change the order of these if statements
  // This is to catch a special case when we don't want to display any ETA info
  if (!data?.delivery_started && data?.delivered)
    return "ORDER SENT TO RESTAURANT";
  if (data?.delivered) return "ORDER DELIVERED";
  if (!data?.delivery_eta) return "ORDER SENT TO RESTAURANT";
  if (data?.delivery_delay_reason && data?.delivery_delay_reason?.trim() !== "")
    return data?.delivery_delay_reason;
  let now = moment(new Date());
  let eta = moment(data?.delivery_eta).local();
  let duration = Math.floor(moment.duration(eta.diff(now)).asMinutes());

  if (duration > 45)
    return (
      "ETA " +
      moment(eta).format("h:mm a") +
      checkAndGetTimezone(timezone, true)
    );
  else if (duration > 2) return "ETA " + duration + " minutes";
  else if (duration <= 2) return "ORDER ARRIVING";
};

export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const showStoppedErrorAlert = (_this, restaurantName) => {
  _this.$swal({
    title: `${restaurantName} has indicated that they cannot accept any additional orders at this time due to capacity limitations.`,
    text:
      "If you need to speak with us, you can use the live-chat icon at the bottom left of the page, or email us at help@hungerhub.com",
    confirmButtonText: "OK"
  });
};

export const removedFromAccountAlert = _this => {
  _this.$swal({
    title:
      "You account administrator has removed your account from this office. Please contact them or start a chat for further assistance.",
    confirmButtonText: "OK"
  });

  logOut(_this);
};

export const isPresent = obj => {
  if (obj) return obj && Object.keys(obj).length > 0;
  else return false;
};

export const validatePassword = password => {
  return /^(?=.*\d)(?=.*[a-zA-Z]).{8,100}$/.test(password);
};

export const getAllRestaurants = (restaurants, meal) => {
  let allRestaurants = restaurants.filter(res => res?.meal_id == meal?.value);

  return allRestaurants.length > 0
    ? [
        ...allRestaurants[0].menus,
        ...allRestaurants[0].stopped_menus.map(stopped_menu => ({
          ...stopped_menu,
          attributes: { ...stopped_menu?.attributes, stopped: true }
        }))
      ]
    : [];
};

export const getFilteredEmployees = (employees, currentOrganization) => {
  const filtered = employees.filter(
    emp =>
      emp?.attributes?.id !== currentOrganization?.attributes?.id &&
      emp?.attributes?.organization_type == "Location" &&
      emp?.attributes?.organization_active &&
      emp?.attributes?.uncatering &&
      !emp?.attributes?.soft_deleted &&
      emp?.attributes?.active
  );

  return filtered.length >= 1 ? filtered : [];
};

export const onlyDate = date => {
  return date?.split("T")[0] || "";
};

export const onlyTime = date => {
  return (date && date?.split("T")[1]) || "";
};

export const parseDailySubsidy = dailySubsidy => {
  return {
    monday: dailySubsidy?.monday
      ? parseFloat(dailySubsidy?.monday).toFixed(2)
      : 0,
    tuesday: dailySubsidy?.tuesday
      ? parseFloat(dailySubsidy?.tuesday).toFixed(2)
      : 0,
    wednesday: dailySubsidy?.wednesday
      ? parseFloat(dailySubsidy?.wednesday).toFixed(2)
      : 0,
    thursday: dailySubsidy?.thursday
      ? parseFloat(dailySubsidy?.thursday).toFixed(2)
      : 0,
    friday: dailySubsidy?.friday
      ? parseFloat(dailySubsidy?.friday).toFixed(2)
      : 0,
    saturday: dailySubsidy?.saturday
      ? parseFloat(dailySubsidy?.saturday).toFixed(2)
      : 0,
    sunday: dailySubsidy?.sunday
      ? parseFloat(dailySubsidy?.sunday).toFixed(2)
      : 0
  };
};

export const parseDailySubsidyWithFilter = dailySubsidy => {
  const subsidies = {};

  Object.entries(dailySubsidy).forEach(([key, value]) => {
    if (value !== null && value !== "") {
      subsidies[key] = parseFloat(value).toFixed(2);
    }
  });

  return subsidies;
};

export const parseWeeklySubsidy = subsidy => {
  return subsidy ? parseFloat(subsidy).toFixed(2) : 0;
};

export const showAvoidPaymentsAlert = (_this, orgName) => {
  _this.$swal({
    title: `Credit card payment has been disabled for ${orgName}, please contact your office administrator.`,
    confirmButtonText: "OK"
  });
};

export const getAdjustedCredit = (availableCredit, needToPayBeforeCredit) => {
  const credit = parseFloat(availableCredit);
  const creditDifference = parseFloat(needToPayBeforeCredit - credit).toFixed(
    2
  );

  if (parseFloat(creditDifference) <= parseFloat(0.2)) {
    return parseFloat(creditDifference).toFixed(2);
  } else return 0;
};

export const showOrderPlacedAlert = _this => {
  _this.$swal({
    title: "Thank you, your order has been placed!",
    text:
      "We'd love to hear from you! Leave feedback about your meal on the Orders page. If you need to speak with us, you can use the live-chat icon at the bottom left of the page, or email us at help@hungerhub.com.",
    confirmButtonText: "OK"
  });
};

export const formatDateWithTimezone = (
  date,
  format,
  timeZone = "America/New_York"
) => {
  let offset = timeZone
    ? moment()
        .tz(timeZone)
        ?.utcOffset()
    : 0;
  return moment(date)
    .local()
    .utcOffset(offset)
    .format(format);
};

export const formatInputPhoneNumber = (value, { isDeleting }) => {
  if (!value) return "";

  if (isDeleting && (value == "+" || value == "+1" || value == "+1 "))
    return value;

  if (value == "+" || value == "+1" || value == "+1 ") return value;

  const hasPlusOne = value.startsWith("+1");

  let digits = value.startsWith("+1")
    ? value.slice(2)
    : value.startsWith("+")
    ? value.slice(1)
    : value;

  digits = digits.replace(/\D/g, "").slice(0, 10);

  if (digits.length < 4) return hasPlusOne ? `+1 ${digits}` : digits;
  if (digits.length < 7)
    return hasPlusOne
      ? `+1 (${digits.slice(0, 3)}) ${digits.slice(3)}`
      : `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return hasPlusOne
    ? `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
    : `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const isValidPhoneNumber = phone => {
  if (!phone) return false;

  // Remove all non-digit characters
  let digits = phone.replace(/\D/g, "");

  // If starts with '1' and length > 10, strip the leading 1 (country code)
  if (digits.startsWith("1") && digits.length > 10) {
    digits = digits.slice(1);
  }

  // Validate: exactly 10 digits
  return digits.length == 10;
};



// WEBPACK FOOTER //
// ./src/utils/common.js